import type { SVGProps } from "react";
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.734 15.492H5.766a1.76 1.76 0 0 1-1.758-1.758V5.766c0-.97.788-1.758 1.758-1.758h7.968c.97 0 1.758.788 1.758 1.758v7.968a1.76 1.76 0 0 1-1.758 1.758M5.766 5.18a.587.587 0 0 0-.586.586v7.968c0 .323.263.586.586.586h7.968a.587.587 0 0 0 .586-.586V5.766a.587.587 0 0 0-.586-.586zm-2.93 5.625H2.25a.587.587 0 0 1-.586-.586V2.25c0-.323.263-.586.586-.586h7.969c.323 0 .586.263.586.586v.557h1.172V2.25A1.76 1.76 0 0 0 10.219.492H2.25A1.76 1.76 0 0 0 .492 2.25v7.969c0 .97.789 1.758 1.758 1.758h.586z"
    />
  </svg>
);
export default SvgCopy;
